import React, { useEffect } from 'react';
import { themes } from '../styles/themes';

const ThemeProvider = ({ children, themeName = 'chauffeur' }) => {
  useEffect(() => {
    const theme = themes[themeName];
    if (theme) {
      Object.entries(theme).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value);
      });
    }
  }, [themeName]);

  return <>{children}</>;
};

export default ThemeProvider;